import React, {useEffect, useState} from 'react';
import './InstallAppPrompt.css';

const DISMISSED = 'connext-install-dismissed';
const standalone = () => Boolean(navigator.standalone || window.matchMedia?.('(display-mode: standalone)').matches);
const dismissed = () => {try {return sessionStorage.getItem(DISMISSED)==='true';} catch {return false;}};

export default function InstallAppPrompt({eligible}) {
  const [installEvent,setInstallEvent]=useState(null);
  const [installed,setInstalled]=useState(standalone);
  const [hidden,setHidden]=useState(dismissed);
  const [ready,setReady]=useState(false);
  const [instructions,setInstructions]=useState(false);
  const [busy,setBusy]=useState(false);
  const ios=/iPad|iPhone|iPod/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
  const close=()=>{setHidden(true);try{sessionStorage.setItem(DISMISSED,'true');}catch{}};
  useEffect(()=>{
    const capture=event=>{event.preventDefault();setInstallEvent(event);};
    const complete=()=>{setInstalled(true);setInstallEvent(null);};
    const mode=window.matchMedia?.('(display-mode: standalone)');
    const changed=()=>setInstalled(standalone());
    window.addEventListener('beforeinstallprompt',capture);
    window.addEventListener('appinstalled',complete);
    mode?.addEventListener?.('change',changed);
    return()=>{window.removeEventListener('beforeinstallprompt',capture);window.removeEventListener('appinstalled',complete);mode?.removeEventListener?.('change',changed);};
  },[]);
  useEffect(()=>{
    setReady(false);
    if(!eligible)return undefined;
    const timer=setTimeout(()=>setReady(true),1500);
    return()=>clearTimeout(timer);
  },[eligible]);
  const install=async()=>{
    if(!installEvent){setInstructions(true);return;}
    setBusy(true);
    try{
      await installEvent.prompt();
      const result=await installEvent.userChoice;
      if(result.outcome==='accepted')setInstalled(true);
      else close();
    }catch{setInstructions(true);}
    finally{setInstallEvent(null);setBusy(false);}
  };
  if(!eligible||!ready||hidden||installed)return null;
  return <aside className="install-app-prompt" dir="rtl" aria-labelledby="install-app-title">
    <button className="install-app-close" aria-label="סגירת הצעת ההתקנה" onClick={close}>×</button>
    <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="" width="52" height="52"/>
    <div><h2 id="install-app-title">Connext במסך הבית שלכם</h2>
    <p>ספיד דייטינג במרחק נגיעה. הוסיפו את האפליקציה למסך הבית לגישה מהירה.</p></div>
    {instructions&&<p className="install-app-help" role="status">{ios
      ? 'פתחו את Connext ב־Safari, לחצו על שיתוף ובחרו ״הוסף למסך הבית״, ואז ״הוסף״. אם מופיעה האפשרות ״פתח כיישום אינטרנט״, השאירו אותה פעילה.'
      : 'פתחו את תפריט הדפדפן וחפשו ״התקנת אפליקציה״ או ״הוספה למסך הבית״. אם האפשרות אינה מופיעה, נסו לפתוח את האתר ב־Chrome או ב־Edge.'}</p>}
    <div className="install-app-actions"><button disabled={busy} onClick={install}>{busy?'פותחים התקנה…':installEvent?'התקנת האפליקציה':'איך מוסיפים למסך הבית?'}</button><button onClick={close}>אולי אחר כך</button></div>
  </aside>;
}
